import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ComplianceCourseProgressModel } from 'src/app/models/dashboard/compliance-course-progress.model';
import { TableColumn } from 'src/app/models/table-column.model';

@Component({
    selector: 'app-compliance-course-qualification-status-widget-demo',
    templateUrl: './compliance-course-qualification-status-widget-demo.component.html',
    styleUrl: './compliance-course-qualification-status-widget-demo.component.scss',
    standalone: false
})
export class ComplianceCourseQualificationStatusWidgetDemoComponent {
  complianceCourseProgresses: ComplianceCourseProgressModel[] =  [
    { id: '1', name: 'Data Security', numberOfPersonsCompleted: 8, numberOfPersonsOpen: 2 },
    { id: '2', name: 'Workplace Safety', numberOfPersonsCompleted: 5, numberOfPersonsOpen: 5 }
  ];

  complianceCoursesQualificationData: any[] = [];

  complianceCoursesQualificationColumns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.NAME'),
      dataField: 'name',
      dataType: 'string',
      disableFiltering: true,
      cssClass: 'width-200',
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.PROGRESS'),
      dataField: 'progress',
      dataType: 'string',
      disableFiltering: true,
    }
  ];

  constructor(private translateService: TranslateService) {
    
  }

  ngOnInit(): void {
    this.complianceCoursesQualificationData = this.complianceCourseProgresses
    .map(d => {
      const total = d.numberOfPersonsCompleted + d.numberOfPersonsOpen;
      const percentage = total > 0 ? Math.round((d.numberOfPersonsCompleted / total) * 100) : 0;

      return {
        ...d,
        progress: `${d.numberOfPersonsCompleted} / ${total}`,
        progressPercentage: percentage + '%'
      };
    });
  }
}
